
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 85.333 512 341.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#338AF3","d":"M0 85.337h512v341.326H0z"}}),_c('path',{attrs:{"fill":"#6DA544","d":"M0 426.663V85.337h512"}}),_c('path',{attrs:{"fill":"#FFDA44","d":"M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"}}),_c('path',{attrs:{"d":"M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"}})])
          )
        }
      }
    